<template lang="pug">
    v-form.c-form.mt-2( @submit.prevent="submit")

        // Email field
        v-text-field(
            name="email"
            :label="$t('fields.email')"
            type="email"
            v-model.lazy="model.email"
            v-validate="'required|email'"
            :data-vv-as="$t('fields.email')"
            :error-messages="errors.collect('email')"
            outlined
        )

        div.controls
            div

                // redirect to reset password page
                router-link(a to="/login") {{ $t('auth.forgotPassword.link') }}
            div

                // Submit button
                v-btn.mr-0.submit(
                    type="submit"
                    color="primary"
                    large
                    :action="submit"
                    :isLoading="isLoading"
                ) {{ $t('auth.forgotPassword.button') }}

</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new',
        },
        data() {
            return {
                model: {
                    email: null,
                },
                visibility: false,
            };
        },
        computed: {
            ...mapGetters('auth', ['isLoading']),
        },
        mounted() {
            const dict = {
                custom: {
                    email: {
                        email: 'Invalid Email',
                        required: 'Email field is required',
                    },
                },
            };

            this.$validator.localize('en', dict);
        },
        methods: {
            ...mapActions('auth', ['passwordReset']),

            /**
             * Send email with password recovery link
             */
            async submit() {
                const validation = await this.$validator.validateAll();

                if (!validation) return;

                this.passwordReset(this.model.email);
            },
        },
    };
</script>

<style lang="stylus" scoped>
    .controls
        display: flex
        justify-content: space-between
        align-items: center
</style>
